import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditTipoAbonadoComponent } from "./edit-tipo-abonado/edit-tipo-abonado.component";

@Component({
  selector: "app-tipo-abonado",
  templateUrl: "./tipo-abonado.component.html",
  styleUrls: ["./tipo-abonado.component.scss"],
})
export class TipoAbonadoComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditTipoAbonadoComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
